import React from "react";
import {
  Form,
  Input,
  Button,
  Tooltip,
} from "antd";
import "antd/dist/reset.css";
import "../../assets/css/forgot-password.css";
import { forgotPassword } from "../../features/auth/authSlice";
import { useDispatch } from "react-redux";

export default function ForgotPassword() {
  const dispatch = useDispatch();
  const onFinish = async (values) => {
    const payload = { email: values.forgotEmail }
    dispatch(forgotPassword(payload));
  };
  return (
    <div className="container">
      <div className="head-text">Reset Password</div>
      <div className="lpass-box-text">
        Just enter your email address below and we'll <br /> send you
        verification code on your email to reset <br /> password
      </div>
      <Form name="forgot_password" className="login-form-lpass" onFinish={onFinish}>
        <Form.Item
          name="forgotEmail"
          hasFeedback
          rules={[
            {
              type: "forgotEmail",
              message: "email is not Valid!",
            },
            {
              required: true,
              message: "Please add your email address",
            },
          ]}
        >
          <Input placeholder="Enter your email" id="validating" />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button-lpass"
          >
            Send Verification Code
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}
